export default __webpack_public_path__ + "static/media/molo-design01.91f6d1d9.png";